import PropTypes from "prop-types";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Icon from "@mui/material/Icon";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import MDBox from "components/MDBox";
import {
  collapseItem,
  collapseIconBox,
  collapseIcon,
  collapseText,
} from "examples/Sidenav/styles/sidenavCollapseStyle";

import { useMaterialUIController } from "context";

function SidenavCollapse({ icon, name, active, noCollapse, nested = false, open = null, ...rest }) {
  const [controller] = useMaterialUIController();
  const { miniSidenav, transparentSidenav, whiteSidenav, darkMode, sidenavColor } = controller;

  return (
    <ListItem component="li" sx={{ pl: nested ? 1.9 : 1 }}>
      <MDBox
        {...rest}
        sx={[
          (theme) =>
            collapseItem(theme, {
              active,
              transparentSidenav,
              whiteSidenav,
              darkMode,
              sidenavColor,
            }),
          (theme) =>
            active
              ? {
                  // usa corbase1 se existir; senão, mantém o azul "info"
                  background: theme.functions.linearGradient(
                    theme.palette.corbase1?.main ?? theme.palette.info.main,
                    theme.palette.corbase1?.focus ?? theme.palette.info.focus
                  ),
                  color: theme.palette.white.main,
                }
              : {},
        ]}
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        width="100%"
      >
        <MDBox display="flex" alignItems="center" width="100%">
          <ListItemIcon
            sx={(theme) =>
              collapseIconBox(theme, { transparentSidenav, whiteSidenav, darkMode, active })
            }
          >
            {typeof icon === "string" ? (
              <Icon sx={(theme) => collapseIcon(theme, { active })}>{icon}</Icon>
            ) : (
              icon
            )}
          </ListItemIcon>

          <ListItemText
            primary={name}
            sx={(theme) =>
              collapseText(theme, {
                miniSidenav,
                transparentSidenav,
                whiteSidenav,
                darkMode, // <- acrescenta
                active,
              })
            }
          />
        </MDBox>

        {/* seta visível apenas se for pai (não nested) e tiver open definido */}
        {open !== null && !nested && (
          <Icon fontSize="small" sx={{ mr: 1 }}>
            {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </Icon>
        )}
      </MDBox>
    </ListItem>
  );
}

SidenavCollapse.defaultProps = {
  active: false,
  noCollapse: false,
  nested: false,
  open: null,
};

SidenavCollapse.propTypes = {
  icon: PropTypes.node.isRequired,
  name: PropTypes.string.isRequired,
  active: PropTypes.bool,
  noCollapse: PropTypes.bool,
  nested: PropTypes.bool,
  open: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf([null])]),
};

export default SidenavCollapse;
